import { checkOpenHouseHealth } from "../utils/networkHealth";

export const useGetPingTime = async () => {
  try {
    const result = await checkOpenHouseHealth();

    if (result.status === "offline") {
      return null;
    }

    return result.latencyMs ?? null;
  } catch (error) {
    console.error("Error fetching ping time:", error);
    return null;
  }
};
